import { render, staticRenderFns } from "./OverwriteLiveModal.vue?vue&type=template&id=13037e9a&scoped=true&"
import script from "./OverwriteLiveModal.vue?vue&type=script&lang=js&"
export * from "./OverwriteLiveModal.vue?vue&type=script&lang=js&"
import style0 from "./OverwriteLiveModal.vue?vue&type=style&index=0&id=13037e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13037e9a",
  null
  
)

export default component.exports